import { createStyles } from '@material-ui/styles'
import logoBackground from 'assets/logo-bg.svg'

export default () =>
    createStyles({
        wrapper: {
            background: 'radial-gradient(circle at 105% -24%, rgba(31, 37, 51, 0.9), #0e1117 35%)',
            width: '100vw',
            height: '100vh',
            '&:before': {
                backgroundImage: `url(${logoBackground})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom left',
                position: 'absolute',
                content: "''",
                width: '100%',
                height: '100%',
            },
        },
    })
